import { render, staticRenderFns } from "./family-view-page.vue?vue&type=template&id=6910c2d9&"
import script from "./family-view-page.vue?vue&type=script&lang=js&"
export * from "./family-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports